<template>
  <v-col
    cols="12"
    md="6"
  >
    <v-card class="account-details mb-1">
      <v-card-title>
        Summary Details
        <v-chip
          v-if="name"
          class="ma-2"
          :color="name === 'dahabshiil.com' ? 'green' : 'blue'"
          label
          small
          text-color="white"
        >
          <v-icon left>
            mdi-link-variant
          </v-icon>
          {{ name }}
        </v-chip>
      </v-card-title>
      <ul class="report-details-list">
        <li
          v-for="(item, index) in tenantFields"
          :key="index"
          class="report-details-list__item"
        >
          <b>{{ item.text }}</b>
          {{ data[item.value] }}
        </li>
      </ul>
      <v-card-actions>
        <v-btn
          color="orange lighten-2"
          text
          @click="showWalletGroups = !showWalletGroups"
        >
          {{ showWalletGroups ? "Hide Wallet Groups" : "Show Wallet Groups" }}
        </v-btn>
        <v-spacer />
        <v-btn
          icon
          @click="showWalletGroups = !showWalletGroups"
        >
          <v-icon>
            {{ showWalletGroups ? "mdi-chevron-up" : "mdi-chevron-down" }}
          </v-icon>
        </v-btn>
      </v-card-actions>
      <v-expand-transition>
        <div v-show="showWalletGroups">
          <v-divider />
          <v-card-text>
            <v-simple-table>
              <template v-slot:default>
                <thead>
                  <tr>
                    <th class="text-left">Currency</th>
                    <th class="text-left">Rate</th>
                    <th class="text-left">Actual Balance</th>
                    <th class="text-left">In-Transit</th>
                    <th class="text-left">Reported Balance</th>
                    <th class="text-left">Bank Currency</th>
                    <th class="text-left">Reported Balance ({{ bankCurrency }})</th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="group in data.walletGroups"
                    :key="group.currency"
                  >
                    <td>{{ group.currency }}</td>
                    <td>{{ group.rate }}</td>
                    <td>{{ group.actualBalance }}</td>
                    <td>{{ group.inTransitAmount }}</td>
                    <td>{{ group.reportedBalance }}</td>
                    <td>{{ group.bankCurrency }}</td>
                    <td>{{ group.reportedBalanceInBankCurrency }}</td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </v-card-text>
        </div>
      </v-expand-transition>
    </v-card>
  </v-col>
</template>

<script>
import { getSafeguardingTenantFields } from "@/utils/staticTablesColumns";

export default {
  name: "CardSafeguardingTenantDetail",
  props: {
    name: {
      type: String,
      default: ""
    },
    data: {
      type: Object,
      default: () => ({})
    },
    bankCurrency: {
      type: String,
      default: ""
    },
    additionalCurrency: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      showWalletGroups: false
    };
  },
  computed: {
    tenantFields() {
      return getSafeguardingTenantFields(this.bankCurrency, this.additionalCurrency);
    }
  }
};
</script>
